module.exports = __webpack_public_path__ + "img/功率.49d79fb6.png";